import styled from 'styled-components'

const Footer = styled.footer.attrs((props) => ({}))`
	--footerTitle: var(--sp9x);
	--footerDescriptionMaxWidth: var(--sp100x);
	--descriptionRouteBlockMarginTop: var(--sp8x);
	--lottieWidth: 21.5%;
	--socialsMarginTop: calc(var(--sp4-5x) * -1);
	--socialLinkMarginRight: var(--sp10x);
	--privacyBlockMarginTop: var(--sp11x);
	--privacyLinkMarginRight: var(--sp13x);
	--copyrightMarginTop: var(--sp11x);
	--copyrightMarginBottom: var(--sp10x);
	--iconSize: var(--sp8x);

	.translate-200 {
		transform: translateY(200%);
	}

	.space {
		margin-left: var(--spSize);
	}

	.copyright {
		justify-content: space-between;
		margin: var(--copyrightMarginTop) 0 var(--copyrightMarginBottom) 0;
	}

	.privacyBlock {
		margin-top: var(--privacyBlockMarginTop);
		.privacyLink {
            display: block;
			margin-right: var(--privacyLinkMarginRight);
		}
	}

	.descriptionAndRouteBlock {
		margin-top: var(--descriptionRouteBlockMarginTop);
		position: relative;

		.lottieMainWrap {
			width: var(--lottieWidth);
			position: absolute;
			top: -105%;
			right: 0;
			.LottieWrap {
				width: 100%;
				height: 100%;
			}
		}
	}

	.socials {
		position: relative;
		margin-top: var(--socialsMarginTop);
		.socialLink {
			margin-right: var(--socialLinkMarginRight);
			i {
				font-size: var(--iconSize);
			}
		}
	}

	.imageCont {
		width: 100%;
		padding-top: 0.6%;
		z-index: -1;
	}

	.footerTitle {
		margin-top: var(--footerTitle);
	}

	.footerDescription {
		max-width: var(--footerDescriptionMaxWidth);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--footerTitle: var(--sp8x);
		--footerDescriptionMaxWidth: var(--sp80x);
		--footerDescriptionMarginTop: var(--sp6x);
		--lottieWidth: 19.5%;
		--descriptionRouteBlockMarginTop: var(--sp6x);
		--socialLinkMarginRight: var(--sp5x);
		--socialsMarginTop: calc(var(--sp3-5x) * -1);
		--privacyBlockMarginTop: var(--sp8x);
		--privacyLinkMarginRight: var(--sp10x);
		--copyrightMarginTop: var(--sp8x);
		--copyrightMarginBottom: var(--sp8x);
		--iconSize: var(--sp5x);

		.descriptionAndRouteBlock {
			.lottieMainWrap {
				top: -125%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--footerTitle: var(--sp7x);
		--footerDescriptionMaxWidth: var(--sp55x);
		--footerDescriptionMarginTop: var(--sp5x);
		--lottieWidth: 20%;
		--descriptionRouteBlockMarginTop: var(--sp5x);
		--socialLinkMarginRight: var(--sp7x);
		--socialsMarginTop: var(--sp1-5x);
		--privacyBlockMarginTop: var(--sp5x);
		--privacyLinkMarginRight: var(--sp7x);
		--copyrightMarginTop: var(--sp5x);
		--copyrightMarginBottom: var(--sp6x);
		--iconSize: var(--sp5x);

		.descriptionAndRouteBlock {
			.lottieMainWrap {
				top: -110%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--footerTitle: var(--sp6x);
		--footerDescriptionMaxWidth: var(--sp41x);
		--footerDescriptionMarginTop: var(--sp4x);
		--lottieWidth: 27%;
		--descriptionRouteBlockMarginTop: var(--sp4x);
		--socialLinkMarginRight: var(--sp6x);
		--socialsMarginTop: var(--sp6x);
		--privacyBlockMarginTop: var(--sp5x);
		--privacyLinkMarginRight: var(--sp6x);
		--copyrightMarginTop: var(--sp5x);
		--copyrightMarginBottom: var(--sp5x);
		--iconSize: var(--sp4x);

		.descriptionAndRouteBlock {
			.lottieMainWrap {
				top: -60%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--footerTitle: var(--sp5x);
		--footerDescriptionMaxWidth: var(--sp41x);
		--footerDescriptionMarginTop: var(--sp4x);
		--lottieWidth: 35.8%;
		--descriptionRouteBlockMarginTop: var(--sp4x);
		--socialLinkMarginRight: var(--sp6x);
		--privacyBlockMarginTop: var(--sp4x);
		--privacyLinkMarginRight: var(--sp7x);
		--copyrightMarginTop: var(--sp5x);
		--copyrightMarginBottom: var(--sp4x);
		--iconSize: var(--sp4x);
		--socialsMarginTop: var(--sp6x);

		.descriptionAndRouteBlock {
			.lottieMainWrap {
				top: -35%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--footerTitle: var(--sp4x);
		--footerDescriptionMaxWidth: 100%;
		--footerDescriptionMarginTop: var(--sp3x);
		--lottieWidth: 40%;
		--descriptionRouteBlockMarginTop: var(--sp3x);
		--socialLinkMarginRight: var(--sp2x);
		--privacyBlockMarginTop: var(--sp4x);
		--privacyLinkMarginRight: 0;
		--copyrightMarginTop: var(--sp4x);
		--copyrightMarginBottom: var(--sp5x);
		--iconSize: var(--sp3x);
		--socialsMarginTop: var(--sp5x);

		.conceptLinkWrap {
			transform: translateY(300%);
		}

		.copyrightYear {
			margin-top: var(--sp2x);
		}

		.copyright {
			flex-direction: column;
		}

		.privacyBlock {
			flex-direction: column;
			.privacyLink {
				margin-bottom: var(--sp2x);
			}
		}

		.socials {
			.socialLink {
				margin-bottom: var(--sp2x);
				transform: translateY(150%);
			}
		}

		.descriptionAndRouteBlock {
			.lottieMainWrap {
				top: 105%;
			}
		}

		.imageCont {
			padding-top: 1.4%;
			.image {
				object-fit: contain;
			}
		}
	}
`

export default Footer
